module.exports = __webpack_public_path__ + "static/media/icon-plus3.0f5ecf86.svg";